import { z } from 'zod'

export const IpSchema = z.object({
    ip: z.string().ip().nonempty(),
})
